import * as React from 'react';
import LocalDiv from '../../../localization/LocalDiv';
import { FLEX_ROW, FLEX_COLUMN } from '../../../layout/flexBox';
import { css } from '@emotion/core';
import { onMobileDevice } from '../../../globalStyle/mediaQueries';
import { COLORS } from '../../../globalStyle/colors';
import Spacer from '../../../layout/Spacer';


const styles = {
  root:     css`
    align-items: center;
    justify-content: space-between;

    ${onMobileDevice} {
      flex-direction: column-reverse;
    }
  `,
  content:  css`
    align-items: baseline;
    margin-top: 20px;
    color: ${COLORS.DARK_GREY};

    ${onMobileDevice} {
      align-self: flex-start;
    }
  `,
  homeLink: css`
    text-decoration: none;
    color: ${COLORS.DARK_GREY};

    &:hover {
      opacity: .6;
      cursor:pointer;
    }
  `,
  title:    css`
    font-weight: normal;
    font-size: 26px;
    ${onMobileDevice} {
      font-size: 18px;
    }
    margin: 0 5px;
  `,
  subtitle: css`
    font-size: 13px;
    margin: 0 5px;
  `,
};


type Props = {
  title: string;
  subtitle: string;
  className?: string;
};


/**
 * CollaboratorPageHeader: a component that renders the page header used on all pages for dev plan collaborators
 */
const CollaboratorPageHeader: React.FC<Props> = props => (
  <LocalDiv css={[FLEX_ROW, styles.root]} className={props.className}>
    <LocalDiv css={[FLEX_COLUMN, styles.content]}>
      <h1 css={styles.title}>{props.title}</h1>
      <Spacer sizePx={8} />
      <p css={styles.subtitle}>{props.subtitle}</p>
    </LocalDiv>
  </LocalDiv>
);

export default CollaboratorPageHeader;
